import { CustomerAssessmentsAction } from "./customer-assessments.action";

export const CUSTOMER_ASSESSMENTS_MESSAGE_CONTEXT = {
	submitAnswers: CustomerAssessmentsAction.submitAnswers.type,
	getAssessment: CustomerAssessmentsAction.getAssessment.type,
	getCustomerAssessments: CustomerAssessmentsAction.getCustomerAssessments.type,
};

export const CUSTOMER_ASSESSMENTS_MESSAGE_CODES = {
	submitAnswers: {
		success: "M_CUSTOMER_ASSESSMENTS_SUBMIT_SUCCESS",
		error: "E_CUSTOMER_ASSESSMENTS",
	},
};
